import gql from 'graphql-tag';

export const MEMBER_LOGIN = gql`
    query($email: String!, $password: String!) {
        memberLogin(email: $email, password: $password) {
            accessToken
        }
    }
`;
export const GET_MEMBER_ID = gql`
    query {
        getLoginMember {
            member_no
            family_name
            given_name
            family_name_kana
            given_name_kana
            gender
            birth_date
            zipcode
            address1
            address2
            mobile_number
            email
            line_link_flag
            member_rank
        }
    }
`;

export const FORGOT_PASSWORD_MAIL = gql`
    mutation($email: String!, $family_name: String, $given_name: String) {
        forgotPasswordMail(
            email: $email
            family_name: $family_name
            given_name: $given_name
        ) {
            token
        }
    }
`;

export const CHANGE_FORGOT_PASSWORD = gql`
    mutation(
        $url_token: String!
        $password: String!
        $password_confirmation: String!
    ) {
        changeForgotPassword(
            url_token: $url_token
            password: $password
            password_confirmation: $password_confirmation
        ) {
            result
        }
    }
`;

export const LINE_LOGIN = gql`
    query($providerName: SocialAuthProvider!, $operationType: OperationType!, $golf_code: String) {
        getSocialAuthUrl(
            providerName: $providerName
            operationType: $operationType
            golf_code: $golf_code
        ) {
            url
        }
    }
`;

export const LOGIN_AT_LINE = gql`
    query($providerName: SocialAuthProvider!) {
        memberLoginUsingSocial(providerName: $providerName) {
            accessToken
        }
    }
`;

export const RESERVE_LOGIN_AT_LINE = gql`
    query($providerName: SocialAuthProvider!, $redirectName: String!, $golfCode: String) {
        reserveLoginUsingSocial(providerName: $providerName, redirectName: $redirectName, golfCode: $golfCode) {
            accessToken
        }
    }
`;

export const CHECK_TMP_MEMBER_PW = gql`
    query($token: String!) {
        getMemberNoTokenTmpPassword(token: $token) {
            member_no
            valid_flag
        }
    }
`;

export const GET_MEMBER_STATUS = gql`
    query($member_no: Int) {
        GetMemberStatus(member_no: $member_no) {
            member_status_type
        }
    }
`;

export const UPDATE_TMP_DATA = gql`
    mutation($id: String!, $member_no: ID!) {
        UpdateTempData(
            id: $id
            member_no: $member_no
        ) {
            result
        }
    }
`;